export class HeaderDatos {
    usuario: string;
    recaptcha: string;
    ipCliente: string;
    idAplicacion: number;
    idAliado: number;
    idCanal: number;
    canal: string;
    consultamultiusuario: boolean;
    consultamulticanal: boolean;
}

export class HeaderAdicionales {
    codigo: string;
    valor: string;
}